import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { pageService } from '../services/api';
import LatestAnnouncements from '../components/LatestAnnouncements';
import PrincipalMessage from '../components/PrincipalMessage';
import HistorySection from '../components/HistorySection';
import ControllerMessage from '../components/ControllerMessage';
import './HomePage.css';
import Melchior from '../images/Melchior.jpg';
import AnilKumar from '../images/AnilKumar.jpg';
import AnilKumar2 from '../images/AnilKumar2.png';
import office4 from '../images/office4.jpg';
import office2 from '../images/office2.jpg';

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // HomePage no longer needs to fetch its own content
    // Child components handle fetching their respective sections
  }, []);

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <div>
      {/* Banner Section */}
      
            
             <div class="container">
            <h1>Welcome to Andhra Loyola College</h1>
          <div class="row mb-5 text-justify">
                <PrincipalMessage />
                <HistorySection />
                <ControllerMessage />
                        
             </div>
                        
            

               
                   
                      
                      
               <section class="controller-examinations">
                    <div class="row">
                        <div class="col-md-8">
                            
                           
                        
                    
                    
                     
                            <LatestAnnouncements />
                      
                      
                    <p class="text-left pt-2"><a href="/announcements" class="btn btn-primary btn-sm">View All Notices →</a></p>


                        </div>
                        <div class="col-md-4">
                            <h3 class="sidebar-title">Quick Links</h3>
        
                    <section class="quick-links-widget">
                        <a href="https://alcerp.in/students/studentlogin.aspx" target="_blank" class="quick-link-btn primary">UG Student Portal Login</a>
                        <a href="https://alcerp.in//STUDENTS/PG/LOGIN.ASPX" target="_blank"  class="quick-link-btn secondary">PG Student Portal Login</a>
                        <a href="#" class="quick-link-btn brown-btn">Student online Services</a>
						<a href="#" class="quick-link-btn brown-btn">Course Structure</a>
						<a href="#" class="quick-link-btn brown-btn">Evaluation Process</a>
						
                    </section>
        
                    
                        </div>
                        
                    </div>
               </section>       
             
              </div>
 </div>

      

  );
};

export default HomePage;
